import { Description, ProductFact } from "@components/views/AboutUsView/model/typedef";
import SocialInCircle from "../../../../../public/images/socialInCircle.svg";
import ProInCircle from "../../../../../public/images/proInCircle.svg";
import MoneyInCircle from "../../../../../public/images/moneyInCircle.svg";
import TargetInCircle from "../../../../../public/images/targetInCircle.svg";

export const productFacts: ProductFact[] = [
	{
		description: "Каждый участник Selfschool может свободно делиться знаниями в любом удобном формате",
	},
	{
		description:
			"Нет обязательных домашних заданий. Мы делаем упор на пользователей с мотивацией к учебе, короткие программы и живое общение с преподавателем",
	},
	{
		description:
			"Множество категорий учебных программ: академические науки, прикладные дисциплины, цифровые специальности, хобби, бытовые навыки, творчество",
	},
	{
		description: "Широкий выбор бесплатных и платных продуктов",
	},
];

export const descriptions: Description[] = [
	{
		title: "Погружение в команду единомышленников",
		icon: SocialInCircle,
	},
	{
		title: "Возможность проявить себя и раскрыть свои таланты",
		icon: ProInCircle,
	},
	{
		title: "Способ монетизации собственных знаний и опыта",
		icon: MoneyInCircle,
	},
	{
		title: "Процессы саморазвития и знакомства с Self-made версией себя",
		icon: TargetInCircle,
	},
];
